import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import { getModuleValue, useWindowSize } from "../../Helpers";
import BrandLogo from "@components/BrandLogo";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import Button from "@components/Button";
import StickyButton from "../../components/StickyButton";
import prizeBg from "@assets/decor.png";
import ultraPrizeBg from "@assets/ultraDecor.png";
import bonusPkt from "@assets/bonus-pkt.png";
import bonusPktMob from "@assets/bonus-pkt-mob.png";
import { useNavigate, useParams } from "react-router";
import DOMPurify from "dompurify";

export default function OutroTemplate({
  userPayload,
  data,
  gameQuestionsQuery,
}) {
  const { width } = useWindowSize();
  const { ident } = useParams();
  const XGA = width >= 1020;
  const navigate = useNavigate();
  const isUltraInsider =
    location.pathname.includes("/subscription") ||
    location.pathname.includes("/ultra-insider") ||
    location.pathname.includes("/ultrainsider");
  1;

  const hasFailed = !userPayload?.isCorrect;

  return (
    <section
      className={`activities-finish-page ${
        isUltraInsider ? "ultra-insider" : ""
      }`}
    >
      <div className="success">
        <PagesHeader>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(getModuleValue(
                data?.content?.modules,
                hasFailed ? "description_fail" : "description_success",
                "metadata.title",
              )),
            }}
          ></p>
        </PagesHeader>
        <div className="desktop-wrapper">
          <div className="main-content-wrapper">
            <LinearGradientProgressBar value={1} />
            <div className="game-question">
              <p
                className="desc"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(getModuleValue(
                    data?.content?.modules,
                    hasFailed ? "description_fail" : "description_success",
                    "custom",
                  )),
                }}
              ></p>
            </div>
            {data?.payout !== 0 && (
              <div className="reward-box">
                <div className="copy">Du&nbsp;erhältst: </div>
                <div className="value">
                  <img
                    className="img"
                    src={isUltraInsider ? ultraPrizeBg : prizeBg}
                    alt={userPayload?.payout}
                  />
                  <div className="prize">
                    <div className="inner">
                      +{userPayload?.payout}
                      <span className="prize-copy">Punkte</span>
                    </div>
                  </div>
                </div>
                {userPayload?.bonus !== 0 && (
                  <div className="bonus-value">
                    <img
                      className="bonus-img"
                      src={XGA ? bonusPkt : bonusPktMob}
                      alt={userPayload?.bonus}
                    />
                    <div className="bonus-prize">
                      <div className="bonus-inner">
                        +{userPayload?.bonus}
                        <span className="bonus-prize-copy">Punkte</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            {data.ident === "vuse_fragrance" && (
              <p className="desc-custom">
                *Registriere dein Gerät oder verbinde dein Vuse Ultra mit der
                MYVUSE App, um Ultra Space freizuschalten.
              </p>
            )}
            <div className="exhange-cta">
              {isUltraInsider && gameQuestionsQuery.ultraInsiderBonusImg && (
                <div className="ultra-insider-reward-box">
                  <BrandLogo brands={data.brands} />
                  <img
                    className="ultra-insider-reward"
                    src={gameQuestionsQuery.ultraInsiderBonusImg}
                  />
                  <Button
                    btnClass={`outline ${isUltraInsider ? "ultra-insider" : ""} `}
                    href={gameQuestionsQuery?.prizeLink}
                  >
                    {gameQuestionsQuery?.prizeLinkCopy}
                  </Button>
                </div>
              )}
              {gameQuestionsQuery?.customFinishLinkExtra &&
                gameQuestionsQuery?.customFinishButtonCopyExtra && (
                  <Button
                    btnClass={`outline ${isUltraInsider ? "ultra-insider" : ""} `}
                    href={
                      gameQuestionsQuery?.customFinishLinkExtra
                        ? gameQuestionsQuery?.customFinishLinkExtra
                        : "/activities"
                    }
                  >
                    {gameQuestionsQuery?.customFinishButtonCopyExtra
                      ? gameQuestionsQuery?.customFinishButtonCopyExtra
                      : "Zur nächste Aktivität"}
                  </Button>
                )}
            </div>
            {isUltraInsider &&
              gameQuestionsQuery.ultraInsiderBonusImg &&
              XGA && (
                <div className="ultra-insider-reward-box-desktop">
                  <BrandLogo brands={data.brands} />
                  <img
                    className="ultra-insider-reward"
                    src={gameQuestionsQuery.ultraInsiderBonusImg}
                  />
                  <Button
                    btnClass={`outline ${isUltraInsider ? "ultra-insider" : ""} `}
                    href={gameQuestionsQuery?.prizeLink}
                  >
                    {gameQuestionsQuery?.prizeLinkCopy}
                  </Button>
                </div>
              )}
          </div>

          <div className="activity-img">
            <img
              src={getModuleValue(
                data?.content?.modules,
                "hero_image",
                "file.url",
              )}
              alt={getModuleValue(
                data?.content?.modules,
                "hero_image",
                "metadata.imgDesc",
              )}
              className="mobile-img"
            />
            <img
              src={getModuleValue(
                data?.content?.modules,
                "hero_image",
                "file.url",
              )}
              alt={getModuleValue(
                data?.content?.modules,
                "hero_image",
                "metadata.imgDesc",
              )}
              className="desktop-img"
            />
            <BrandLogo desktopBig brands={data?.brands} />
            {XGA && (
              <StickyContent>
                <div className="desktop-buttons">
                  {gameQuestionsQuery?.customFinishLinkExtra &&
                    gameQuestionsQuery?.customFinishButtonCopyExtra && (
                      <Button
                        btnClass={`outline ${isUltraInsider ? "ultra-insider" : ""} `}
                        href={
                          gameQuestionsQuery?.customFinishLinkExtra
                            ? gameQuestionsQuery?.customFinishLinkExtra
                            : "/activities"
                        }
                      >
                        {gameQuestionsQuery?.customFinishButtonCopyExtra
                          ? gameQuestionsQuery?.customFinishButtonCopyExtra
                          : "Zur nächste Aktivität"}
                      </Button>
                    )}
                  <Button
                    href={
                      gameQuestionsQuery?.customFinishLink
                        ? gameQuestionsQuery?.customFinishLink
                        : "/activities"
                    }
                    btnClass={`yellow ${isUltraInsider ? "ultra-insider" : ""} `}
                  >
                    {gameQuestionsQuery?.customFinishButtonCopy
                      ? gameQuestionsQuery?.customFinishButtonCopy
                      : "Zur nächste Aktivität"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
        {!XGA && (
          <StickyButton
            href={
              gameQuestionsQuery?.customFinishLink
                ? gameQuestionsQuery?.customFinishLink
                : "/activities"
            }
          >
            {gameQuestionsQuery?.customFinishButtonCopy
              ? gameQuestionsQuery?.customFinishButtonCopy
              : "Zur nächste Aktivität"}
          </StickyButton>
        )}
      </div>
    </section>
  );
}
